<script>
	import SkyList from 'sky-list';
	import SkySearchMixin from 'sky-search/sky-search.mixin';

	const preferences = {
		api: '/umbraco/api/NewsApi/Search',
		pagination: true,
	};

	const parameters = {
		keywords: '',
		year: '',
	};

	export default {
		name: 'sky-news',
		props: {
			filter: Object,
		},
		mixins: [SkySearchMixin],
		data() {
			return {
				list: new SkyList(preferences, parameters),
				keywords: '',
				year: '',
			};
		},
		computed: {
			showMessage() {
				return this.keywords.length !== 0 || this.year;
			},
			result() {
				const distributed = this.distribute(this.list.results.items);
				return this.sort(distributed);
			},
		},
		created() {
			/**
			 * Populate keywords prop from list if the prop should
			 * have intial value (from url query params for instance)
			 */
			this.keywords = this.list.params.keywords;

			this.year = this.list.params.year;

			this.update();
		},
		watch: {
			keywords() {
				// Keep list keyword param in sync
				this.list.params.keywords = this.keywords;

				this.update();
			},
			year() {
				// Keep list year param in sync
				this.list.params.year = this.year;
				this.update();
			},
		},
		methods: {
			monthConverter(number) {
				const convert = {
					1: 'januar',
					2: 'februar',
					3: 'marts',
					4: 'april',
					5: 'maj',
					6: 'juni',
					7: 'juli',
					8: 'august',
					9: 'september',
					10: 'oktober',
					11: 'november',
					12: 'december',
				};

				const value = (typeof number === 'string') && (number.indexOf('0') === 0)
					? Number(number.replace('0', ''))
					: number;

				return convert[value];
			},
			stripZeroPrefix(value) {
				if (value.indexOf('0') === 0) {
					return value.substr(1);
				}

				return value;
			},
			convertDate(newsdate) {
				const dateArray = newsdate.split('T')[0].split('-');

				const year = dateArray[0];
				const month = this.monthConverter(dateArray[1]);
				const day = this.stripZeroPrefix(dateArray[2]);

				return `${day}. ${month} ${year}`;
			},
			update() {
				this.list.update();
			},
			distribute(array) {
				const base = array || this.list.results.items;

				const result = base.reduce((acc, cur) => {
					const yearExists = acc.find(instance => instance.sortId === cur.year);

					if (!yearExists) {
						acc.push({
							sortId: cur.year,
							name: cur.year,
							months: [],
						});
					}

					const yearInQuestion = acc.find(instance => instance.sortId === cur.year);
					const monthExists = yearInQuestion.months.find(instance => instance.sortId === cur.month);

					if (!monthExists) {
						yearInQuestion.months.push({
							sortId: cur.month,
							name: this.monthConverter(cur.month),
							news: [],
						});
					}

					const monthInQuestion = yearInQuestion.months.find(
						instance => instance.sortId === cur.month,
					);

					monthInQuestion.news.push(cur);

					return acc;
				}, []);

				return result;
			},
			sort(array) {
				const sorted = array.sort((a, b) => a.sortId - b.sortId);

				sorted.forEach((year) => {
					year.months.sort((a, b) => a.sortId - b.sortId);

					year.months.forEach((month) => {
						month.news.sort((a, b) => {
							if (b.newsdate < a.newsdate) {
								return 1;
							}
							return -1;
						});
					});
				});

				return sorted;
			},
		},
	};
</script>

<style src="./sky-news.scss" scoped></style>
<template src="./sky-news.html"></template>



// WEBPACK FOOTER //
// sky-news.vue?d3caa7a0